(function(){
    'use strict';

    angular.module('elogbooks.helpdesk.sites.details', []);
})();
